import type { SVGProps } from "react";

export const Brightdata = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="Layer 1"
    id="Layer_1"
    viewBox="0 0 1033.25 1033.25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Brightdata</title>
    <path
      d="M905.7,0H127.56A127.56,127.56,0,0,0,0,127.58V905.7a127.56,127.56,0,0,0,127.56,127.55H905.7A127.55,127.55,0,0,0,1033.23,905.7V127.58A127.56,127.56,0,0,0,905.7,0Zm-463,286.1c7-17.07,12.05-33.16,2-52.25,13.08,5,19.09,13.05,25.11,24.12,10.05-6,15.07-15.09,17.09-25.12s4-20.11,7.05-30.14c4-10,10-18.09,22.09-24.13-6,18.11,4,28.15,14.07,39.2,12,14.07,22.11,28.14,33.14,41.19,12.07-20.08,12.07-20.08,22.13-25.12-11.06,22.11,1,42.19,4,62.3,6,42.19-17.09,80.37-57.26,89.42-29.14,6-57.29,3-77.37-21.1C434.67,341.36,431.63,314.24,442.71,286.1ZM640.13,852.87H421V803.73l53.23-6.92v-281l-49.1-15.92V445.21l134.15-18,28.37-2.79v371.7l52.53,7.61Z"
      fill="#3d7ffc"
    />
  </svg>
);

export default Brightdata;
